import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface';
import { PMYTFilterConfig } from './filters/PMYTFilterConfig';
export const PMYTTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.PMYT],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: PMYTFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: PMYTFilterConfig,
      AreaPath: [UATConstants.PMYTAreaPath],
      Title: UATConstants.TenantTitles.PMYT,
      ADOTitle: UATConstants.TenantADOText.PMYT,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreatePartnerMarketingYieldTracker,
          Key: UATConstants.CreateActionMenuKey.CreatePartnerMarketingYieldTracker,
          NodeName: '',
        },
      ],
      BulkUpload: true,
      DownloadTemplate: true,
      DownloadTemplateConfig: {
        tenantToolName: 'pmyt',
        title: UATConstants.PlaceholdersAndTitles.PMYT,
        excelColumnSequence: {
          'Title': 1,
          'Assigned Team': 2,
          'Preferred Partner Name (UAT)': 3,
          'Partner One ID': 4,
          'Solution Area (UAT)': 5,
          'PMYT_Areas': 6,
          'PMYT_CoInvestmentAmount': 7,
          'PMYT_CustomerSegment': 8,
          'PMYT_EstimatedCosellReferrals': 9,
          'PMYT_EstimatedPipelineRevenue': 10,
          'PMYT_EstimatedStartDate': 11,
          'PMYT_Industries': 12,
          'PMYT_InvestmentAmount': 13,
          'PMYT_PartnerType': 14,
          'PMYT_SolutionPlays': 15,
          'PMYT_SourceOfInvestment': 16,
        },
      },
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: false,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: true,
      BulkEditConfig: [],
      CreateRAID: false,
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedto', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '72547d16-7404-46ff-a229-44664d489d2e',
      systemViewsFolderId: '72547d16-7404-46ff-a229-44664d489d2e',
      sharedViewsFolderId: '903cdb85-81f4-443c-aadc-55e5d0435f17',
    },
  },
};
